export default __webpack_public_path__ + "static/media/price-tag.3c9abd28.svg";